require('./region_brand.js');
require('../util/currency-field.js');

document.addEventListener('DOMContentLoaded', claims);

function createEnhancedUploadField(Element) {
  const FileUploadContainer = document.createElement('div');
  FileUploadContainer.id = Element.id;
  FileUploadContainer.classList = Element.classList;

  const FileList = document.createElement('div');
  FileList.classList.add('file-list');
  FileUploadContainer.appendChild(FileList);

  const AddRowButton = document.createElement('button');
  AddRowButton.classList = 'file-list__add btn text-primary';
  AddRowButton.type = 'button';
  AddRowButton.innerText = 'Upload additional files';
  AddRowButton.addEventListener('click', addFileRow);
  FileUploadContainer.appendChild(AddRowButton);

  Element.parentNode.appendChild(FileUploadContainer);

  function addFileRow(event) {
    if (event) event.preventDefault();
    const count = FileList.childElementCount;

    const FileListItem = document.createElement('div');
    FileListItem.classList = 'file-list__item d-flex mb-2';

    const FileInput = document.createElement('input');
    FileInput.type = 'file';
    FileInput.id = `${Element.id}_${count}`;
    FileInput.name = Element.name;
    FileInput.addEventListener('change', () => {
      const files = FileInput.files;
      if (files && files[0]) {
        const file = files[0];
        NameInput.value = file.name;
      }
    });
    FileListItem.appendChild(FileInput);

    const NameInput = document.createElement('input');
    NameInput.classList.add('form-control');
    NameInput.value = name;
    NameInput.readOnly = true;
    NameInput.addEventListener('click', () => {
      FileInput.click();
    });
    FileListItem.appendChild(NameInput);

    const BrowseButton = document.createElement('button');
    BrowseButton.classList = 'btn btn-primary';
    BrowseButton.type = 'button';
    BrowseButton.innerText = 'Browse';
    BrowseButton.addEventListener('click', () => {
      FileInput.click();
    });
    FileListItem.appendChild(BrowseButton);

    const RemoveButton = document.createElement('button');
    RemoveButton.classList = 'btn text-danger';
    RemoveButton.type = 'button';
    RemoveButton.innerText = 'Remove';
    RemoveButton.addEventListener('click', () => {
      FileListItem.parentNode.removeChild(FileListItem);
    });
    FileListItem.appendChild(RemoveButton);

    FileList.appendChild(FileListItem);
  }

  addFileRow();
}

function claims() {
  // Add claim
  const addForm = document.querySelector('#new_claim');
  const addFormSuccess = document.querySelector('.success-message');

  if (addForm && addFormSuccess) {
    addForm.addEventListener('ajax:success', () => {
      addForm.classList.add('d-none');
      addFormSuccess.classList.remove('d-none');
    });
  }

  // Lookup claim
  const lookupForm = document.querySelector('#lookup_claim');
  const uploadForm = document.querySelector('#upload_claim');
  const uploadFormSuccess = document.querySelector('.success-message');
  if (lookupForm && uploadForm) {
    lookupForm.addEventListener('ajax:error', error => {
      console.log('error', error);
      const lookupErrorText = lookupForm.querySelector('.claim-error');
      lookupErrorText.classList.remove('d-none');
    });
    lookupForm.addEventListener('ajax:success', () => {
      lookupForm.classList.add('d-none');
      uploadForm.classList.remove('d-none');
      const claimNumber = lookupForm.querySelector('.claim-number').value;
      const email = lookupForm.querySelector('.email').value;
      const claimField = uploadForm.querySelector('.claim-number');
      const emailField = uploadForm.querySelector('.email');
      claimField.value = claimNumber;
      emailField.value = email;
    });
    uploadForm.addEventListener('ajax:success', () => {
      uploadForm.classList.add('d-none');
      uploadFormSuccess.classList.remove('d-none');
    });
  }

  // Setup enhanced upload fields
  const enhancedFields = document.querySelectorAll('.enhanced-file-upload');
  enhancedFields.forEach(createEnhancedUploadField);
}
